module.exports = __webpack_public_path__ + "img/18ne.6a2aee91.svg";